export default __webpack_public_path__ + "static/media/addposition-aqua.f447c1d3.svg";